import { render, staticRenderFns } from "./ClientOtherModal.vue?vue&type=template&id=552b949d&scoped=true&"
import script from "./ClientOtherModal.vue?vue&type=script&lang=js&"
export * from "./ClientOtherModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552b949d",
  null
  
)

export default component.exports